<template>
  <div>
    <h5 class="font-bold ml-5">
      <a-icon class="mr-10" type="unordered-list" />Club
    </h5>
    <a-table
      :columns="columnsClub"
      :data-source="dataListClub"
      :pagination="false"
      :loading="loadingClub"
      bordered
      class="mb-5"
    >
      <template slot="footer" slot-scope="currentPageData">
        <small class="mt-0 mb-0"
          >count club : {{ dataListClub.length }} rows</small
        >
      </template>
    </a-table>
  </div>
</template>

<script>
const columnsClub = [
  {
    title: "Term",
    dataIndex: "budget_detail.plan_detail.term",
    scopedSlots: { customRender: "budget_detail.plan_detail.term" },
  },
  {
    title: "Year",
    dataIndex: "budget_detail.plan_detail.academic_year",
    className: "",
    scopedSlots: { customRender: "budget_detail.plan_detail.academic_year" },
  },
  {
    title: "Name [En]",
    dataIndex: "club_name",
    className: "",
    scopedSlots: { customRender: "club_name" },
  },
  {
    title: "Position",
    dataIndex: "position",
    className: "",
    scopedSlots: { customRender: "position" },
  },
];
export default {
  data() {
    return {
      columnsClub,
      dataListClub: [],
      loadingClub: false,
    };
  },
  mounted() {
    this.getListEventClub();
  },
  methods: {
    async getListEventClub() {
      this.loadingClub = true;
      this.dataListClub = [];
      try {
        const res = await this.$http.get(`/student-activities/club/me/`);
        if (res.status === 200) {
          this.dataListClub = res.data;
          if (this.dataListClub.length !== 0) {
            this.dataListClub.sort((a, b) => {
              return (
                b.budget_detail.plan_detail.academic_year -
                a.budget_detail.plan_detail.academic_year
              );
            });
          }
          this.loadingClub = false;
        } else {
          const error = new Error('Request Failed');
          error.res = res;
          error.response = res;
          throw error;
        }
      } catch (error) {
        this.loadingClub = false;
        this.dataClub = [];
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [
              h("strong", { class: "" }, `Error ${error.response.status}`),
            ]);
          },
          description: `Problem issue connect api : /student-activities/club/me/`,
        });
      }
    },
  },
};
</script>